import { api } from './api'
import { schluesselBytes } from './erinnerungen'

/** Web-Push gibt es nur mit Service Worker, Push-Manager und Benachrichtigungen (iOS: nur als zum Home-Bildschirm hinzugefügte App) */
export const pushMoeglich = () => 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window

async function abo() {
  const registrierung = await navigator.serviceWorker.ready
  return { registrierung, abo: await registrierung.pushManager.getSubscription() }
}

/** Ist dieses Gerät abonniert (und beim Server bekannt)? */
export async function pushAktiv(): Promise<boolean> {
  if (!pushMoeglich() || Notification.permission !== 'granted') return false
  return (await abo()).abo !== null
}

/** Fragt nach der Erlaubnis und meldet das Gerät beim Server an. Muss aus einem Klick heraus aufgerufen werden. */
export async function pushAktivieren(): Promise<void> {
  if (!pushMoeglich()) throw new Error('Dieses Gerät oder dieser Browser unterstützt keine Benachrichtigungen.')
  const { schluessel } = await api.pushStand()
  if (!schluessel) throw new Error('Benachrichtigungen sind auf dem Server nicht eingerichtet.')
  if ((await Notification.requestPermission()) !== 'granted') throw new Error('Benachrichtigungen sind für diese Seite nicht erlaubt.')
  const { registrierung, abo: vorhanden } = await abo()
  const neu = vorhanden ?? (await registrierung.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: schluesselBytes(schluessel) }))
  // Auch ein schon vorhandenes Abonnement erneut melden: Der Server kennt es vielleicht nicht (mehr).
  await melden(neu)
}

/** Meldet das Abonnement samt Geräteschlüsseln an; der Server verschlüsselt damit die Nutzlast (Firefox verwirft Weckrufe ohne). */
function melden(neu: PushSubscription) {
  const { keys } = neu.toJSON()
  return api.pushAbonnieren(neu.endpoint, { p256dh: keys?.p256dh, auth: keys?.auth })
}

/** Gleicht ein vorhandenes Abonnement still mit dem Server ab (ältere Abonnements kennen dort noch keine Geräteschlüssel). */
export async function pushErneuern(): Promise<void> {
  if (!pushMoeglich() || Notification.permission !== 'granted') return
  const { abo: vorhanden } = await abo()
  if (vorhanden) await melden(vorhanden)
}

export async function pushDeaktivieren(): Promise<void> {
  const { abo: vorhanden } = await abo()
  if (!vorhanden) return
  await api.pushAbbestellen(vorhanden.endpoint)
  await vorhanden.unsubscribe()
}

export type PushHinweisArt = 'unmoeglich' | 'aus'

/**
 * Warum dieses Gerät eine fällige Erinnerung nicht melden würde: null, wenn alles in Ordnung ist (oder der Server gar keine
 * Benachrichtigungen verschickt, dann hilft der Nutzer nichts). Erinnerungen stehen immer in der App, geweckt wird nur ein angemeldetes Gerät.
 */
export async function pushHinweisArt(): Promise<PushHinweisArt | null> {
  const { schluessel } = await api.pushStand()
  if (!schluessel) return null
  if (!pushMoeglich()) return 'unmoeglich'
  return (await pushAktiv()) ? null : 'aus'
}
